

const TRANSLATIONS_PT_PT = {
    "email_otp.back":"Voltar",
    "email_otp.enter_email_text":"Introduza o seu endereço de e-mail abaixo para receber um código de utilização única",
    "email_otp.send_verification_link":"Enviar código de verificação",
    "email_otp.resend_otp_with_timer":"Reenviar OTP em",
    "email_otp.text":"Enviámos um código de verificação de 6 dígitos para [email]. Introduza o código abaixo",
    "email_otp.verify":"Verificar",
    "reset_password.set_password":"Redefina a sua palavra-passe",
    "sign_in.or":"ou",
    "sign_in.continue_with":"Ou continue com",
    "sign_in.continue_with_email":"Ou continue com o e-mail",
    "sign_in.create_without_password":"Crie uma conta sem palavra-passe",
    "sign_in.create_with_otp":"Criar uma conta com um código de utilização única",
    "sign_in.login_with_otp":"Iniciar sessão com um código de utilização única",
    "sign_in.login_without_password":"Iniciar sessão sem palavra-passe",
    "sign_in.tooltip_text":"Vai receber por e-mail um código de verificação temporário de utilização única para ter acesso à sua conta.",
    "sign_up.tooltip_text":"Vai receber por e-mail um código de verificação temporário de utilização única para criar uma conta.",
    "sign_in.password_updated":"A sua palavra-passe foi atualizada.",
    "sign_up.create_an_account":"Crie uma conta",
    "email_otp.resend_otp":"Reenviar OTP",
    "sign_up.email_address":"Endereço de e-mail",
    "sign_up.password":"Senha",
    "sign_in.create_account" : "Crie uma conta",
    "sign_in.title": "Iniciar Sessão",
    "sign_in.forgot_password" : "Esqueceu sua senha?",
    "reset_password.resend_email": "Reenviar e-mail",
    "reset_password.sent_title": "E-mail enviado!",
    "reset_password.rcvResetLink": "insira o seu endereço de email abaixo, enviar-lhe-emos o link onde poderá substituir a sua palavra-passe",
    "reset_password.submit": "Enviar",
    "reset_password.back_to_login": "Voltar ao início de sessão",
    "reset_password.create_new_password": "Crie uma nova senha para fazer login na sua conta.",
    "forgot_password.emailSent": "Se já existir uma conta para [], será enviada uma mensagem de e-mail com uma hiperligação para redefinir a palavra-passe. Ainda não recebeu? Solicitar uma nova mensagem de e-mail abaixo.",
    "gdpr.continue": "Continuar",
    "validation.password_validation_heading": "A palavra-passe deve incluir:",
    "validation.password_length_ui": "Pelo menos 8 caracteres ",
    "validation.password_upper_case_ui": "Uma letra maiúscula",
    "validation.password_lower_case_ui": "Uma letra minúscula",
    "validation.password_number_ui": "Um número",
    "validation.password_symbol_ui": "Um caracter especial",
    "verify_otp.customer_service_center_link": "s/serviço-de-atendimento-ao-cliente",
    "activate_user.verification_successful.message": "Parabéns! A sua conta foi ativada.",
    "activate_user.already_verified.message" : "Damos-lhe as boas-vindas de volta! A sua conta já foi verificada.",

    // Errors Translation
    "sign_in.mandatory_field_error": "Preencha todos os campos obrigatórios antes de continuar.",
    "sign_in.invalid_email_error": "Introduza o e-mail num formato adequado, por exemplo, nome@dominio.com",
    "sign_in.invalid_credentials_error": "Introduziu um nome de utilizador ou palavra-passe inválidos. Tente novamente.",
    "sign_in.generic_error": "Algo falhou. Tente novamente.",
    "sign_in.account_unverified_error": "A sua conta ainda não está ativada. Verifique o link de ativação que enviámos para o seu e-mail ou clique em “Esqueceu-se da palavra-passe?” para redefinir o acesso à conta.",
    "sign_in.max_attempt_error": "Atingiu o número máximo de tentativas. Tente novamente mais tarde.",
    "sign_in.social_signin_error": "Falha no início de sessão nas redes sociais (Google/facebook/apple). Tente novamente ou utilize outro método de início de sessão",
    "sign_in.social_signin_email_not_present_error": "O início de sessão falhou. Tente novamente ou utilize outra opção de início de sessão.",
    "sign_in.guest_user_signin_error": "Aparentemente, já tem uma conta associada a este e-mail. Clique em Esqueci-me da palavra-passe para redefinir o acesso à sua conta.",

    "sign_up.mandatory_field_error": "Preencha todos os campos obrigatórios antes de continuar.",
    "sign_up.invalid_email_error": "Introduza um endereço de e-mail válido, por exemplo, nome@dominio.com",
    "sign_up.password_length_error": "A palavra-passe deve ter pelo menos 8 carateres.",
    "sign_up.email_already_exist_error": "Este endereço de e-mail já existe. Utilize um e-mail diferente.",
    "sign_up.generic_error": "Algo falhou. Tente novamente.",
    "sign_up.password_policy_error": "A palavra-passe deve incluir: um número, um caráter especial [!#$%&'*+-/=?^_`{|}~.@], letras maiúsculas e minúsculas.",
    "sign_up.common_password_error": "A palavra-passe não pode ser igual ao seu endereço de e-mail",

    "forgot_password.mandatory_field_error": "Preencha todos os campos obrigatórios antes de continuar.",
    "forgot_password.invalid_email_error": "Introduza o e-mail num formato adequado, por exemplo, nome@dominio.com",
    "forgot_password.generic_error": "Algo falhou. Tente novamente.",

    "reset_password.mandatory_field_error": "Preencha todos os campos obrigatórios antes de continuar.",
    "reset_password.password_history_error": "A palavra-passe deve ser diferente das suas últimas cinco palavras-passe.",
    "reset_password.password_length_error": "A palavra-passe deve ter pelo menos 8 carateres.",
    "reset_password.password_policy_error": "A palavra-passe deve incluir: um número, um caráter especial [!#$%&'*+-/=?^_`{|}~.@], letras maiúsculas e minúsculas.",
    "reset_password.common_password_error": "A palavra-passe não pode ser igual ao seu endereço de e-mail",
    "reset_password.generic_error": "Algo falhou. Tente novamente.",

    "email_otp.email_required_error": "Introduza o seu e-mail para continuar",
    "email_otp.invalid_email_error": "Introduza um endereço de e-mail válido, por exemplo, nome@dominio.com",
    "email_otp.generic_error": "Algo falhou. Tente novamente mais tarde",
    "email_otp.invalid_otp_error": "A palavra-passe de uso único/código de verificação introduzido não é válido. Tente novamente.",
    "email_otp.resend_otp_error": "Não foi possível reenviar a palavra-passe de uso único. Tente novamente mais tarde",
    "email_otp.verify_otp_error": "Algo falhou. Tente verificar novamente a palavra-passe de uso único mais tarde",
    "email_otp.verify_otp_limit_exceed_error": "A palavra-passe de uso único introduzida não é válida. Clique em “Reenviar palavra-passe de uso único” para obter uma nova",
    "email_otp.max_attempt_reached_error": "Atingiu o número máximo de tentativas. Tente novamente mais tarde.",
    "email_otp.brute_force_error_part_1": "A sua conta foi temporariamente bloqueada devido a múltiplas tentativas de início de sessão malsucedidas. Tente novamente mais tarde ou ",
    "email_otp.brute_force_error_part_2": "contacte o nosso Centro de Ajuda",
    "email_otp.brute_force_error_part_3": " para obter apoio.",
    "form.gdprconsent": "Ao iniciar sessão, confirma que leu e aceitou os nossos",
    "form.termsCondition": "Termos e condições",

    //Page Titles
    "sign_in.page_title": "Iniciar Sessão | Pens.com",
    "sign_up.page_title": "Inscrever se | Pens.com",
    "forgot-password.page_title": "Esqueci Senha | Pens.com",
    "reset-password.page_title": "Restabelecer Senha | Pens.com",
    "sign-in.password_icon_aria_label_blured": "Blured Show password",
    "sign-in.password_icon_aria_label": "Show password",
    "sign-in.password_icon_aria_label_hidden": "Hide password",
    "sign-in.tooltip_icon_aria_label": "More Info",
    "email_otp.otp_digit_aria_label": "Please enter the code",
};
export default TRANSLATIONS_PT_PT;